import React, { Component } from 'react'
import { Row, Col, Card, Table, Button, Container, Form, Modal } from "react-bootstrap";
import CardLessDataTableWithSearch from '../datatables/CardLessDataTableWithSearch';


class LeadsModalDetails extends Component {

    articlecolumns = [
        {
            dataField: "lead_name",
            text: "Lead Name",
            sort: true,
        },
        {
            dataField: "lead_mobile",
            text: "Lead Mobile",
            sort: true,
        },
        {
            dataField: "father_name",
            text: "Father Name",
            sort: true,
        },
        {
            dataField: "father_contact_no",
            text: "Father Mobile",
            sort: true,
        },
        {
            dataField: "source_name",
            text: "Source",
            sort: true,
        },
        {
            dataField: "city",
            text: "Location",
            sort: true,
        },

    ];

    tableData(data) {
        let returnData = [];
        data.map((item) => {

            const newObj = {
                lead_name: item.lead_name,
                lead_mobile: item.lead_mobile,
                father_name: item.father_name,
                father_contact_no: item.father_contact_no,
                source_name:item.source_name,
                city:item.city
            }
          
            returnData.push(newObj);
        });
        return returnData;
    }

    render() {
        return (
            <Modal
                {...this.props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title className="modal-title">Leads Details</Modal.Title>
                </Modal.Header>
                <Container fluid>
                    <Modal.Body className="p-4">
                        <Row>
                            <Col lg={12} md={12} sm={12} className='mt-3'>

                                {
                                    this.props.stateData.selectedCardData.length > 0 ?
                                        (

                                            <CardLessDataTableWithSearch
                                                parentData={this.tableData(this.props.stateData.selectedCardData)}
                                                particlecolumns={this.articlecolumns}
                                                name="attendance"
                                            />

                                        ) : (
                                            <Col ls={12} md={12} sm={12}>
                                                <h4 className='mt-3 text-center'><span className="text-danger"> * </span> No data available</h4>
                                            </Col>
                                        )
                                }
                            </Col>
                        </Row>

                    </Modal.Body>
                </Container>

            </Modal>)
    }
}

export default LeadsModalDetails